import { getAppId, getEmail, setCounties, setToken } from "../Common";
import { applicationManagement, etdLookups } from "./apiService";

export const getResource = (
  ResourceType,
  ResourceParam,
  ResourceParam2,
  url
) => {
  const payload = {
    ApplicationId: getAppId(),
    EmailAddress: getEmail(),
    ResourceParam: ResourceParam,
    ResourceParam2: ResourceParam2,
    ResourceType: ResourceType,
  };
  //const payloads = { ResourceType:'Purpose'};
  return applicationManagement(payload, url)
    .then((result) => {
      setCounties(result?.data);
      //setToken(result?.token)
      if (result?.data) {
        return result?.data;
      }
    })
    .catch((error) => {
      return "technicalError";
    });
};

export const getDocuments = (
  ResourceType,
  ResourceParam,
  ResourceParam2,
  url
) => {
  const payload = {
    ResourceParam: ResourceParam,
    ResourceParam2: ResourceParam2,
    ResourceType: ResourceType,
  };
  //const payloads = { ResourceType:'Purpose'};
  return applicationManagement(payload, url)
    .then((result) => {
      setCounties(result?.data);
      //setToken(result?.token)
      if (result?.data) {
        return result?.data;
      }
    })
    .catch((error) => {
      return "technicalError";
    });
};
